import { PlanItem } from "../../plan.model";
import { Tooth } from "../../../../odontogram/odontogram.model";
import { ItemValidators } from "../../../item-validators";
import { AbstractTreatment } from "../treatment";

export class ScalingRootPlanning extends AbstractTreatment {
  static validate(
    item: PlanItem,
    odontogram: Tooth[],
    items: PlanItem[],
  ): boolean {
    // validate teeth selected
    if (!ItemValidators.hasTeethSelected(item)) {
      return false;
    }

    // validate not missing
    if (!ItemValidators.notMissingTeeth(item, odontogram)) {
      return false;
    }

    return true;
  }

  static apply(odontogram: Tooth[], item: PlanItem): Tooth[] {
    return odontogram;
  }

  static getIdentifier(): string {
    return "scaling-root-planning";
  }
}



// WEBPACK FOOTER //
// /app/src/app/core/store/plan-editor/plan/treatments/perio/scaling-root-planning.ts